// ThreeDotMenu.js
import React from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Flex,
  Text,
} from '@chakra-ui/react';

const ThreeDotMenu = ({ icon, items }) => {
  return (
    <Menu>
      <MenuButton
        as={IconButton}
        icon={icon}
        variant="ghost"
        color="gray"
        size="sm"
      />
      <MenuList>
        {items.map(({ icon: itemIcon, text, onClick, extraIcon }, index) => (
          <MenuItem
            key={index}
            fontSize="sm"
            color="gray.500"
            onClick={onClick}
          >
            <Flex alignItems="center">
              {itemIcon}
              <Text ml={2}>{text}</Text>
              {extraIcon && (
                <span style={{ marginLeft: '8px', display: 'inline-flex', alignItems: 'center' }}>
                  {extraIcon}
                </span>
              )}
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default ThreeDotMenu;
